var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.data),function(row,i){return [_c('tg-agent-cell',{key:i,attrs:{"row":row}}),(i < _vm.lastIndex)?[_vm._v(" > ")]:_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }